import { render } from "./SearchResult.vue?vue&type=template&id=563aa8f8&scoped=true"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"

import "./SearchResult.vue?vue&type=style&index=0&id=563aa8f8&lang=scss&scoped=true"

import exportComponent from "/Users/andyhsieh/Desktop/tourist-site-project-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-563aa8f8"]])

export default __exports__